import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";


const FlightLogTable = ({ data }) => {
  if (!data?.length) return null;

  return (
    <TableContainer variant="outlined" sx={{ maxHeight: "65vh" }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow
            sx={{
              "& th": {
                fontWeight: 600,
                backgroundColor: "neutral.light",
                borderBottom: "1px solid",
                borderColor: "divider"
              }
            }}
          >
            <TableCell width={150}>Date Time</TableCell>
            <TableCell width={110}>Changed By</TableCell>
            <TableCell>Description</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((log) =>
            log.logDetails?.map((detail, idx) => (
              <TableRow key={`${log._id}-${idx}`} hover>
                <TableCell>
                  <Typography variant="body2">
                    {detail.logDayTime}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {detail.logChangedBy}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Box>
                    <Typography variant="body2">
                      {detail.logDescription}
                    </Typography>                    
                  </Box>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default FlightLogTable;